export type ArrayKey = number;

function getPropertyValue<T>(targetObject: T, dataToRetrieve: string) {
  return dataToRetrieve
    .split(".") // split string based on `.`
    .reduce(function (o, k) {
      return o && (o[k as keyof typeof o] as never); // get inner property if `o` is defined else get `o` and return
    }, targetObject); // set initial value as object
}

export const getSortByObjectValue =
  <T>(name: string, direction: "asc" | "desc") =>
  (a: T, b: T) => {
    const v1 = getPropertyValue(a, name);
    const v2 = getPropertyValue(b, name);

    if (typeof v1 === "string" && typeof v2 === "string") {
      return v1.localeCompare(v2) * (direction === "asc" ? 1 : -1);
    }

    if (typeof v1 === "number" && typeof v2 === "number") {
      return (v1 - v2) * (direction === "asc" ? 1 : -1);
    }

    if (typeof v1 === "boolean" && typeof v2 === "boolean") {
      return (v1 === v2 ? 0 : v1 ? 1 : -1) * (direction === "asc" ? 1 : -1);
    }

    if (v1 instanceof Date && v2 instanceof Date) {
      return (v1.getTime() - v2.getTime()) * (direction === "asc" ? 1 : -1);
    }

    return 0;
  };

export const sortByTwoKeys = <T>(
  a: T,
  b: T,
  primarySort: keyof T,
  secondarySort: keyof T,
): number => {
  const aPrimary = a[primarySort];
  const bPrimary = b[primarySort];
  if (aPrimary < bPrimary) {
    return 1;
  }
  if (aPrimary > bPrimary) {
    return -1;
  }

  const aSecondary = a[secondarySort];
  const bSecondary = b[secondarySort];
  if (typeof aSecondary === "string" && typeof bSecondary === "string") {
    return aSecondary.localeCompare(bSecondary);
  }

  return 0;
};
